import axios from "axios";
import { get } from "lodash";
import { toastr } from "react-redux-toastr";
import { Group } from "../../utils/logger";

import {
  CAMPAIGN_ONOFF_ERROR,
  CAMPAIGN_ONOFF_LOADING,
  SET_CAMPAIGNS_ONOFF,
  CAMPAIGN_ONOFF_DATABASE_UPDATE,
  CAMPAIGN_ONOFF_DATABASE_UPDATING,
  CAMPAIGN_ONOFF_DATABASE_UPDATE_ERROR,
} from "../constants";

const LoggerGroup = new Group("CampaignOnOff Actions", { disable: true });

export const campaignLoading = (type) => (dispatch) => {
  dispatch({ type: CAMPAIGN_ONOFF_LOADING, payload: type });
};

export const getCampaignsOnOff = () => (dispatch, getState) => {
  LoggerGroup.emit(" [i] Fetching Campaign OnOff Result For Filter: ");
  dispatch(campaignLoading(CAMPAIGN_ONOFF_LOADING));

  return axios
    .get(`admin/campaignOnOff`)
    .then(async (res) => {
      let campaignResult = get(res, "data.list");
      //convert to chicago
      if (campaignResult) {
        for (let i = 0; i < campaignResult.length; i++) {
          if (campaignResult[i].updated_at) {
            campaignResult[i].updated_at = new Date(
              campaignResult[i].updated_at
            ).toLocaleString("en-US", { timeZone: "America/Chicago" });
          }
          if (campaignResult[i].subtype === "") {
            campaignResult[i].subtype = "NO_SUBTYPE";
          }
        }
        LoggerGroup.emit("  [i] Campaign On Off List ", { table: campaignResult }).end();
        dispatch({ type: SET_CAMPAIGNS_ONOFF, payload: campaignResult });
      } else {
        dispatch({ type: SET_CAMPAIGNS_ONOFF, payload: [] });
      }
    })
    .catch((err) => {
      const error_message = get(err, "response.data.error");
      toastr.error("Campaign Listing Error", error_message);
      LoggerGroup.emit({ warn: "[i] Error fetching Campaign List" }, { dir: error_message }).end();
      dispatch({
        type: CAMPAIGN_ONOFF_ERROR,
        payload: { error_message: `Error fetching campaign List`, internal_error: err },
      });

      dispatch({
        type: SET_CAMPAIGNS_ONOFF,
        payload: [],
      });
    });
};

export const updateCampaignOnOff = (campaignDetail) => (dispatch, getState) => {
  LoggerGroup.emit(" [i] Updating Campaign : ", campaignDetail);
  dispatch({ type: CAMPAIGN_ONOFF_DATABASE_UPDATING, payload: campaignDetail });
  return axios
    .patch(`admin/campaignOnOff`, campaignDetail)
    .then((res) => {
      toastr.success("Success", `Channel Status updated successfully!`);
      dispatch(getCampaignsOnOff()); //refresh campaigns list
      dispatch({ type: CAMPAIGN_ONOFF_DATABASE_UPDATE, payload: null });
    })
    .catch((err) => {
      const error_message = get(err, "response.data.error");
      toastr.error("Error!! Campaign call details update failure", error_message);
      LoggerGroup.emit(
        { warn: `[i] Error Updating Campaign ${campaignDetail}` },
        { dir: error_message }
      ).end();
      dispatch(getCampaignsOnOff()); //refresh campaigns list
      dispatch({
        type: CAMPAIGN_ONOFF_DATABASE_UPDATE_ERROR,
        payload: {
          error_message: `Error updating campaign ${campaignDetail.id}`,
          internal_error: err,
        },
      });
    });
};
